/* Norrviva — Making film. Poster + play overlay; click reveals native controls
   and plays. Idempotent; re-runs on Shopify section load in the theme editor. */
(function () {
  function init(frame) {
    if (frame.dataset.filmReady) return;
    frame.dataset.filmReady = '1';
    var video = frame.querySelector('video');
    var btn = frame.querySelector('.nvv-making-film__play');
    if (!video) return;
    var start = function () {
      video.controls = true;
      frame.classList.add('is-playing');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    };
    if (btn) btn.addEventListener('click', start);
    video.addEventListener('play', function () {
      video.controls = true;
      frame.classList.add('is-playing');
    });
  }
  function boot() {
    var frames = document.querySelectorAll('[data-making-film]');
    for (var i = 0; i < frames.length; i++) init(frames[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
